const rodzajCzesci = { t: 'Rodzaj części', name: 'rodzaj-czesci', hint: { url: '/part_kind' }}
export default rodzajCzesci